import FeatureFlagsHelper from './featureFlags/featureFlagsHelper';

export const TABLET_SCREEN_MIN_WIDTH = 768;
export const MOBILE_SCREEN_MAX_WIDTH = 479;

export const CONTENT_PAGE = 'contentPage';
export const PROJECT_PAGE = 'projectPage';

export const TABLET_SHOW_FIELDS_NUMBER_SEO_FOOTER = 16;
export const MOBILE_SHOW_FIELDS_NUMBER_SEO_FOOTER = 4;

export const MAX_CONTENT_HEIGHT = 4200;

export const SCREEN_TYPE: {
  tablet: 'tablet';
  smallDesktop: 'smallDesktop';
  desktop: 'desktop';
  mobile: 'mobile';
} = {
  tablet: 'tablet',
  smallDesktop: 'smallDesktop',
  desktop: 'desktop',
  mobile: 'mobile',
};

export const NO_INFORMATION = 'No Information';
export const NOT_INCLUDED = 'Not Included';

export const ISO3166StandardEUList = [
  'BE',
  'BG',
  'CZ',
  'DK',
  'DE',
  'EE',
  'IE',
  'EL',
  'ES',
  'FR',
  'HR',
  'IT',
  'CY',
  'LV',
  'LT',
  'LU',
  'HU',
  'MT',
  'NL',
  'AT',
  'PL',
  'PT',
  'RO',
  'SI',
  'SK',
  'FI',
  'SE',
  'GB',
  'SM',
  'VA',
  'GR',
];

export const DEFAULT_LANG = 'th-TH';

export const USER_AGENT = 'thinkofliving/tol-web';

export const MILLION_BATH = 'ล้านบาท';
export const BATH_PER_SQM = 'บาท/ตร.ม.';
export const BATH = 'บาท';

export const LOGGED_OUT_OPERATION = {
  REGISTER: 'register',
  LOGIN: 'login',
};

export const DESKTOP_SHOW_TAG_ROWS = 1;
export const MOBILE_SHOW_TAG_ROWS = 2;
export const TAG_READ_MORE_BUTTON_WIDTH = 73;

export const locationTypeMappings = [
  { en: 'zone', th: 'ทำเล-ย่าน' },
  { en: 'metro_station', th: 'รถไฟฟ้า' },
  { en: 'district', th: 'เขต' },
  { en: 'road', th: 'ถนน' },
];

export const latestActiveProjectsParams = {
  status: 'active',
  sort_by: '-launch_date',
};

export const PROJECTNET_ENDPOINTS = {
  PROJECT_DETAIL: '/v1/project',
  SEARCH_PROJECTS: '/v1/projects',
};

export const HTTP_RESPONSE_CODES = {
  OK: 200,
  BadRequest: 400,
  NotFound: 404,
  ServerError: 500,
  PermanentlyMoved: 301,
  TemporarilyMoved: 302,
};

export const ZonePostTag = 'zone-review';
export const TrainlinePostTag = 'trainline-review';

export const isProjectNetSRPActive = () =>
  FeatureFlagsHelper.isActive('Toggle_SRP_ProjectNetSearch');
